import React from 'react';
import { useLocation } from 'react-router-dom';
import { useConfiguration } from '../../context/configurationContext';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
import { matchPathname } from '../../util/routes';
import loadable from '@loadable/component';

import {
  trustpilotAllowedRouteNames,
  trustpilotAllowedCMSPageIds,
} from '../../config/configTrustpilot';
import { TrustpilotSection } from '../../components';

const SectionBuilder = loadable(
  () => import(/* webpackChunkName: "SectionBuilder" */ '../PageBuilder/PageBuilder'),
  {
    resolveComponent: components => components.SectionBuilder,
  }
);

// The Trustpilot section is only shown on the pages Tara picked (2026-07-23) -
// visibility depends on the route only, never on the footer asset content.
const isTrustpilotAllowedPage = (pathname, routeConfiguration) => {
  const found = matchPathname(pathname, routeConfiguration)[0];
  if (!found) {
    return false;
  }
  const { route, params } = found;
  if (trustpilotAllowedRouteNames.includes(route.name)) {
    return true;
  }
  return route.name === 'CMSPage' && trustpilotAllowedCMSPageIds.includes(params.pageId);
};

const FooterComponent = () => {
  const { footer = {}, topbar } = useConfiguration();
  const routeConfiguration = useRouteConfiguration();
  const location = useLocation();
  const hasFooter = Object.keys(footer).length > 0;
  const isAllowedPage = isTrustpilotAllowedPage(location.pathname, routeConfiguration);

  // The footer asset does not specify sectionId or sectionType. However, the SectionBuilder
  // expects sectionId and sectionType in order to identify the section. We add those
  // attributes here before passing the asset to SectionBuilder.
  const footerSection = hasFooter
    ? {
        ...footer,
        sectionId: 'footer',
        sectionType: 'footer',
        linkLogoToExternalSite: topbar?.logoLink,
      }
    : null;

  return (
    <>
      {isAllowedPage ? <TrustpilotSection /> : null}
      {hasFooter ? <SectionBuilder sections={[footerSection]} /> : null}
    </>
  );
};

// NOTE: if you want to add dynamic data to FooterComponent,
//       you could just connect this FooterContainer to Redux Store
//
// const mapStateToProps = state => {
//   const { currentUser } = state.user;
//   return { currentUser };
// };
// const FooterContainer = compose(connect(mapStateToProps))(FooterComponent);
// export default FooterContainer;

export default FooterComponent;
